export enum RoutePath {
  LogIn = '/log-in',
  Planogram = '/planogram',
  PlanogramProjects = '/planogram/projects',
  PlanogramDetails = '/planogram/:id',
  AccountSettings = '/account-settings/:id',
  ForgotPassword = '/forgot-password',
  Dashboard = '/dashboard',
  StoreBuilder = '/store-builder',
  StoreBuilderDetails = '/store-builder/:id',
  OVR = '/online-virtual-research',
  OVRDetails = '/online-virtual-research/:id',
  CustomFields = '/custom-fields',
  Manual = '/manual',
  Downloads = '/downloads',
  Permissions = '/permissions',
  PermissionsList = '/permissions/list',
  Users = '/users',
  User = '/users/:id',
  UserStreamSessions = '/users/:id/stream-sessions',
  UserStreamSessionLogs = '/users/:id/stream-sessions/:sessionUuid/logs',
  Client = '/clients/:id',
  Clients = '/clients',
  SystemConfigurations = '/system-configuration',
  OvrFileManagement = '/ovr-file-management',
  Products = '/products',
  ProductDetails = '/product-library/:id',
  ProductDetailsImage = '/product-library/:id/image',
  ProductLibrary = '/product-library',
  ProductList = '/product-list',
  MasterLibrarianList = '/master-librarian-list',
  UploadModels = '/upload-models',
  POGChecker = '/pog-checker',
  MetaData = '/meta-data',
  ReplacementData = '/replacement-data',
  Status = '/status',
  Studio = '/studio',
  StudioOnline = '/studio/online',
  UnitedStates = '/united-states',
  Canada = '/canada',
  Global = '/global',
  Roles = '/roles',
  Feb = '/feb',
  FrontEndBuilder = '/front-end-builder',
  Debug = '/debug',
  MyPermissions = '/debug/my-permissions',
  StudioEnvironments = '/debug/studio-environments',
}
